import hideFromAffiliates from './parts/hideFromAffiliates';

const hideAffiliates = new hideFromAffiliates();
hideAffiliates.hide();
